module.exports = __webpack_public_path__ + "img/user-10.009482a7.jpg";